<script lang="ts" setup>
	import dayjs from 'dayjs'
	import type { TableColumn } from '~/types'

	defineProps<{
		filter?: RecordSchema
	}>()
	defineEmits<{
		(event: 'share'): void
	}>()
	const tableRowClass = 'text-gray-600 text-sm font-medium'
	const tableColumns = shallowRef<TableColumn>([
		{
			title: 'S/N',
			dataIndex: 'sn',
			key: 'sn',
			customCell: () => ({ class: `${tableRowClass} text-center` }),
			width: '50px'
		},
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			customCell: () => ({ class: tableRowClass })
		},
		{
			title: 'Earned',
			dataIndex: 'amount',
			key: 'amount',
			customCell: () => ({ class: tableRowClass })
		},
		{
			title: 'Refer Date',
			dataIndex: 'refer_date',
			key: 'refer_date',
			customCell: () => ({ class: tableRowClass })
		},
		{
			title: 'Status',
			dataIndex: 'status',
			key: 'status',
			customCell: () => ({ class: tableRowClass })
		}
	])
	const { currencyToNaira } = useCurrency()
</script>

<template>
	<shared-table :columns="tableColumns" :filter="filter || {}" source="/referrals">
		<template #empty>
			<shared-empty-state
				:use-button="true"
				title="No Reward"
				desc-class="mt-5 tracking-wide text-gray-500"
				description="Get cash rewards on every friend that signs up with
			your referral link."
			>
				<template #icon>
					<lazy-tools-icon dir="other" icon="giftbox" />
				</template>
				<template #button>
					<button
						type="button"
						aria-describedby="share referral link"
						class="default-btn mt-8 !hidden w-full max-w-[300px] justify-center bg-primary-2 !font-medium tracking-wide sm:!flex"
						@click="$emit('share')"
					>
						Share referral link
					</button>
				</template>
			</shared-empty-state>
		</template>
		<template #bodyCell="{ record, index, column }">
			<span v-if="column?.key === 'sn'">{{ index }}</span>
			<span v-if="column?.key === 'name'">
				{{ record?.referred?.name || 'N/A' }}
			</span>
			<span v-if="column?.key === 'amount'">{{ currencyToNaira(record?.amount || 0) }}</span>
			<span v-if="column?.key === 'refer_date'">
				{{
					(record?.referred?.created_at && dayjs(record?.referred?.created_at).format('DD MMM, YYYY')) ||
					'N/A'
				}}
			</span>
			<shared-badge
				v-if="column?.key === 'status'"
				:text="record?.status"
				:active="!['pending', 'failed'].includes(record?.status)"
				:pending="record?.status === 'pending'"
				:failed="record?.status !== 'failed'"
			/>
		</template>
	</shared-table>
</template>
